import React from 'react';
import TodayCheckInTable from './TodayCheckInTable';

const TodayCheckInList = () => {
  return (
    <div className="row m-0">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Today's Check-in</h4>
            <p className="card-subtitle mb-4">
              List of all check-ins for today.
            </p>
            <TodayCheckInTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodayCheckInList;
